export const normalizeTreatmentPatientId = (value: unknown): number | null => {
    const patientId = typeof value === 'number'
        ? value
        : typeof value === 'string' && value.trim() !== ''
            ? Number(value)
            : NaN

    return Number.isSafeInteger(patientId) && patientId > 0 ? patientId : null
}
